import { render } from "./BaseRadioGroup.vue?vue&type=template&id=20f4339a&ts=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=ts"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__